import React, {useEffect, useState} from 'react';
import styles from './PlatformUsagePieChart.module.scss';

import {ResponsiveRadialBar} from '@nivo/radial-bar'
import _ from "lodash";
import {$t} from "../../helpers/translator";


const PlatformUsagePieChart = (props) => {
    const [pieData, setPieData] = useState(null);

    // console.log(pieData)
    useEffect(() => {
        init();
    }, [])

    function init() {
        if (!props.data) {
            return;
        }

        let data = [];
        _.forEach(props.data, (v, k) => {
            data.push(
                {
                    id: k,
                    data: [{
                        x: $t(`global.machines.pieChart.${k}`),
                        y: v > 0.03 ? v : (v > 0.00 ? 0.03 : 0),
                        // value: 'additional dt'
                    }]
                }
            )
        })

        // console.log('piedatatat', data)
        setPieData(data)
    }

    function renderTooltip(e) {
        let id = e.bar.category;
        let color = e.bar.color
        let value = e.bar.formattedValue;
        // console.log('tt:',e)

        return(
            <div className={styles.tooltipContainer}><div className={styles.tooltipSquare} style={{backgroundColor: color}} /><span>{id}:</span><span className={styles.value}>{value}</span></div>
        )
    }


    return (
        <div className={styles.container} style={{height: props.size, width: props.size}}>
            {/*{pieData ?*/}
                <ResponsiveRadialBar
                    data={pieData}
                    valueFormat=" >-.0%"
                    endAngle={360}
                    padding={0.3}
                    cornerRadius={25}
                    margin={{top: 0, right: 0, bottom: 0, left: 0}}

                    colors={['#F7C59F', '#319AA1', '#473073']}
                    enableRadialGrid={false}
                    enableCircularGrid={false}
                    radialAxisStart={{tickSize: 0, tickPadding: 500, tickRotation: 0}}
                    circularAxisOuter={{tickSize: 0, tickPadding: 100, tickRotation: 0}}
                    maxValue={1}
                    label="value"
                    legends={[]}

                    tooltip={(data) => renderTooltip(data)}

                />
            {/*    :*/}
            {/*    null*/}
            {/*}*/}
        </div>
    );
}

PlatformUsagePieChart.defaultProps = {
    size: 100,
    data: {
        lasing: 0.25,
        treatment: 0.32,
        online: 0.66,
    }
}


export default PlatformUsagePieChart;
